import {
  Header,
  OnChangeFn,
  PageLayout,
  PaginationState,
  Table as RawTable,
  type ITableProps,
  withI18n,
} from '@psyomics/ui-components';
import { useTranslation } from 'react-i18next';

import { ReferralUploadJobErrors } from './referral-upload-job-errors';
import { ServicesForUpload } from './services-for-upload';
import { ReferralUploadJobResult } from './types';
import { useTableColumns } from './use-table-columns';

const TableWithI18n = withI18n<ITableProps<ReferralUploadJobResult>>(RawTable);

const Table = <TData,>(
  props: Parameters<typeof TableWithI18n>[0] & {
    data: TData[];
  }
) => TableWithI18n(props);

type ReferralUploadJobsViewProps = {
  readonly jobs: ReferralUploadJobResult[];
  readonly totalCount: number;
  readonly pagination: PaginationState;
  readonly onPaginationChange: OnChangeFn<PaginationState>;
};

const ReferralUploadJobsView = ({
  jobs,
  totalCount,
  pagination: { pageIndex, pageSize },
  onPaginationChange,
}: ReferralUploadJobsViewProps) => {
  const { i18n, t } = useTranslation();
  const columns = useTableColumns();

  return (
    <PageLayout background="muted" title={t('page.referralUploadJobs.title')} width="wide">
      <ServicesForUpload />
      <Header className="mt-4" level="h2">
        {t('page.referralUploadJobs.previousUploads')}
      </Header>
      <Table
        className="mt-4"
        columns={columns}
        data={jobs}
        i18nInstance={i18n}
        manipulationOptions={{
          currentPage: pageIndex,
          onPaginationChange,
          totalRowCount: totalCount,
          type: 'serverSide',
        }}
        pageSize={pageSize}
        renderSubRow={(job) => <ReferralUploadJobErrors job={job} />}
      />
    </PageLayout>
  );
};

export { ReferralUploadJobsView };
